import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import ServicePackages from '../components/ServicePackages';

const ServicesPage = () => {
  return (
    <>
      <Navbar />
      <ServicePackages />
      <Footer />
    </>
  );
};

export default ServicesPage;
